import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import { makeApiCall } from "src/api/apiRequests";
import Loading from "src/helpers/Loading";
import PATHS from "src/routes/Paths";

const RegisteredSuccessfuly = (): JSX.Element => {
  const { t } = useTranslation("");
  const { token } = useParams();
  const navigate = useNavigate();

  const [firstName, setFirstname] = useState<string>("");
  const [lastName, setLastname] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [guardian, setGuardian] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: any = await makeApiCall<ResponseType>(
          API_PATHS.acceptInvitation(token),
          "GET",
          API_HEADERS.unauthenticated
        );
        setFirstname(response.user.first_name);
        setLastname(response.user.last_name);
        setEmail(response.user.email);

        setGuardian(response.guardian);
        setLoading(false);
      } catch (error: any) {
        navigate(PATHS.login);
      }
    };

    fetchData();
  }, []);

  return loading && guardian ? (
    <div className="text-center">
      <Loading />
    </div>
  ) : (
    <>
      <div className="auth-card">
        <p className="auth-note">{t("registered_successfuly_title")}</p>
        <div className="auth-text">
          <p>
            {t("registered_successfuly_welcome")},{" "}
            <strong>
              {firstName} {lastName}
            </strong>
            !
          </p>
          <p>
            {t("registered_successfuly_email")} <strong>{email}</strong>.
          </p>
          <p>{t("registered_successfuly_check_email")}</p>
        </div>
        <button className="button-blue" onClick={() => navigate(PATHS.login)}>
          {t("registered_successfuly_login")}
        </button>
      </div>
    </>
  );
};

export default RegisteredSuccessfuly;
